//      
export { default } from './use-focus-marshal';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-focus-marshal/index.js